import { SagaIterator } from "@redux-saga/core";
import { startSubmit, stopSubmit } from "redux-form";
import { call, put, takeLatest } from "redux-saga/effects";

import { memberSearchAction } from "@/App/actions";
import { PageAlert } from "@/App/components";
import { ActionTypes } from "@/App/constants/actionTypes";
import { RelationshipCode } from "@/App/constants/constants";
import apiService from "@/App/service";
import { GroupTypes, MembersTypes, PlanAccountTypes, PlanTypes } from "@/types";

interface MemberDataType {
  member: MembersTypes.MemberInformationResult;
  plan: PlanTypes.Plan;
  group: GroupTypes.GroupResults;
  plan_account: PlanAccountTypes.PlanAccountInfo;
}

function* searchMember(data: MembersTypes.MemberSearchOptions): Generator {
  return yield apiService({
    url: "/member/list",
    method: "POST",
    data,
  });
}

function formatData(data: Array<MemberDataType>): Array<MembersTypes.MemberSearchResult> {
  return data.map((val) => {
    return {
      id: val.member.id,
      address_line_1: val.member.address_line_1,
      birth_date: val.member.birth_date,
      city: val.member.city,
      client_id: val.plan.client_id,
      created_at: val.member.created_at,
      effective_date: val.member.effective_date,
      external_account_id: val.plan_account.external_account_id,
      external_group_id: val.group.external_group_id,
      external_member_id: val.member.external_member_id,
      first_name: val.member.first_name,
      last_name: val.member.last_name,
      location: val.member.location,
      person_code: val.member.person_code,
      relationship_code: RelationshipCode[val.member.relationship_code],
      sex: val.member.sex,
      state: val.member.state,
      termination_date: val.member.termination_date,
      updated_at: val.member.updated_at,
      zip_code: val.member.zip_code,
    };
  });
}

function* searchForMemberWorker(action: ReturnType<typeof memberSearchAction.userSearchForMembers>): SagaIterator {
  const { userSearchForMembersResults } = memberSearchAction;
  const { payload, formName } = action;
  const { showPageAlert } = PageAlert;

  try {
    yield put(startSubmit(formName));

    const { results, result_count } = yield call(searchMember, payload);
    const formatSearchResult = formatData(results);

    yield put(userSearchForMembersResults({ results: formatSearchResult, result_count }));
    yield put(stopSubmit(formName));
  } catch (error) {
    yield put(stopSubmit(formName));
    const { data: { message = "" } = {} } = error;
    yield put(showPageAlert({ show: true, type: "error", message: message || error }));
  }
}

export default function* searchForMemberWatcher(): SagaIterator {
  yield takeLatest(ActionTypes.SEARCH_FOR_MEMBER, searchForMemberWorker);
}
